import React, { useState } from 'react';
import { View } from 'react-native';
import ContactListHeadline from './ContactListHeadline';
import ContactListContainer from './ContactListContainer';
import {
  avatar_color_1, avatar_color_2, avatar_color_3, avatar_color_4,
} from '../../../utils/DictionaryManagementUtils';
import { arrangeScreenInJson } from '../../../screens/ScreensOrdering';
import { getDefaultGlobJSON } from '../../../defaultConfigurations/MainConfigurations';

//= ========================================================================

const ContactListMenu = ({
  globJSON, onConfigChanged, selectedScreen, language,
}) => {
  const colorList = [
    avatar_color_1,
    avatar_color_2,
    avatar_color_3,
    avatar_color_4,
  ];
  const [expandEditText, setExpandEditText] = useState(false);
  const onAvatarValueChanged = (value) => {
    globJSON.configurations.general.show_avatar_in_contact_lists = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };
  const resetAvatarColors = () => {
    const { colors } = globJSON.configurations.theme;
    const colorsDefault = getDefaultGlobJSON().configurations.theme.colors;

    colorList.forEach((colorKey) => {
      colors[colorKey] = colorsDefault[colorKey];
    });

    onConfigChanged();
  };

  return (
    <View style={{ marginBottom: 30, marginTop: 8 }}>
      <ContactListHeadline
        language={language}
        expandEditText={expandEditText}
        onValueChanged={(value) => {
          setExpandEditText(value);
        }}
      />
      {expandEditText
        && (
          <ContactListContainer
            globJSON={globJSON}
            onConfigChanged={onConfigChanged}
            onAvatarValueChanged={onAvatarValueChanged}
            showAvatarInContactLists={globJSON.configurations.general.show_avatar_in_contact_lists}
            colorList={colorList}
            resetAvatarColors={resetAvatarColors}
            selectedScreen={selectedScreen}
          />
        )}
    </View>
  );
};
export default ContactListMenu;
